import React from 'react';
// template components
import Accordion from '@nmx/template/dist/componentLibrary/modules/Accordion';
import BulletedList from '@nmx/template/dist/componentLibrary/components/BulletedList';
import Col from '@nmx/template/dist/componentLibrary/foundations/Grid/Col';
import Row from '@nmx/template/dist/componentLibrary/foundations/Grid/Row';
import SectionContainer from '@nmx/template/dist/componentLibrary/components/SectionContainer';
import Typography from '@nmx/template/dist/componentLibrary/foundations/Typography';
import WidowBlock from '@nmx/template/dist/componentLibrary/components/WidowBlock';
// icons
import MinusSignFillIcon from '@nmx/template/dist/componentLibrary/foundations/Icon/icons/utility/MinusSignFill';
import PlusSignFillIcon from '@nmx/template/dist/componentLibrary/foundations/Icon/icons/utility/PlusSignFill';

export default () => (
  <SectionContainer
    id='ltc-insurance-answers-to-common-billing-faq'
    backgroundVariant='lightA'
    themeType='lightTheme'
    disableBottomPadding>
    <Row align='center'>
      <Col
        medium={8}>
        <Typography
          nextElement='graphic'
          component='h1'
          align='center'>
          Long&#45;Term Care <WidowBlock>Insurance FAQ&#39;s</WidowBlock>
        </Typography>
        <Typography
          component='h2'
          nextElement='typography'
          align='center'>
          Answers to Common <WidowBlock>Billing Questions</WidowBlock>
        </Typography>
        <Typography nextElement='typography'>
          Below are a few of the common billing questions typically received from policyowners.
        </Typography>
        <Accordion
          id='ltc-faq-answers-to-common-billing-urgent-notice-faq'
          variant='secondary'
          toggleOpenIcon={PlusSignFillIcon}
          toggleCloseIcon={MinusSignFillIcon}
          isFAQ
          items={[
            {
              id: 'ltc-insurance-urgent-notice-faq',
              title: <>I received an &#34;Urgent Notice&#34; What does <WidowBlock>this mean&#63;</WidowBlock></>,
              contentAs: 'div',
              content: (
                <>
                  <Typography nextElement='typography'>
                    We will send you an Urgent Notice if we don&#39;t receive a check from you within 10 days of the due date.
                  </Typography>
                  <BulletedList
                    bulletType='filledCircle'
                    bulletedListData={[
                      { bulletText: <>If you have mailed your premium, don&#39;t panic. Your payment and the Urgent Notice may have crossed paths in the mail.</> },
                      { bulletText: 'If you have not paid your premium, do so as soon as possible to maintain your coverage.' },
                    ]}
                  />
                </>
              ),
            },
            {
              id: 'ltc-insurance-faq-changes-to-bill-faq',
              title: <>Why are there changes to my <WidowBlock>bill amount&#63;</WidowBlock></>,
              contentAs: 'div',
              content: (
                <>
                  <Typography nextElement='typography'>
                    The amount of your bill may change because:
                  </Typography>
                  <BulletedList
                    bulletType='filledCircle'
                    bulletedListData={[
                      { bulletText: 'Your benefits have increased to keep pace with inflation.' },
                      { bulletText: 'One or more policies have been added to or deleted from your bill.' },
                      { bulletText: 'The annual premium on your term life insurance policy has increased.' },
                      { bulletText: 'Changes have been made to the amount or use of your dividends.' },
                      { bulletText: 'Changes have been made to your policy.' },
                    ]}
                  />
                </>
              ),
            },
          ]}
        />
      </Col>
    </Row>
  </SectionContainer>
);

